// extracted by mini-css-extract-plugin
export default {"stepperRoot":"PointsCoupons_stepperRoot__PDlzs","tableWrapper":"PointsCoupons_tableWrapper__zO84e","tableCell":"PointsCoupons_tableCell__XnNuj"};